import config from '@/language/pt/components/config';
import filters from '@/language/pt/components/filters';
import models from '@/language/pt/components/cards/models';
import filter from '@/language/pt/components/filter';
import PublishSwitch from '@/language/pt/components/PublishSwitch';
import Impress from '@/language/pt/components/Impress';
import OperatorsLogs from '@/language/pt/components/OperatorsLogs';
import CopyToClipboard from '@/language/pt/components/CopyToClipboard';
import AddCardModal from '@/language/pt/components/AddCardModal';
import HiddenCardsModal from '@/language/pt/components/HiddenCardsModal';
import RemoveCardModal from '@/language/pt/components/RemoveCardModal';
import CardModal from '@/language/pt/components/CardModal';
import DashCardsContainer from '@/language/pt/components/DashCardsContainer';
import GlobalFilter from '@/language/pt/components/GlobalFilter';
import GlobalFilterModal from '@/language/pt/components/GlobalFilterModal';
import GlobalFilterSummary from '@/language/pt/components/GlobalFilterSummary';
import Badge from '@/language/pt/components/Badge';
import DashFilterBar from '@/language/pt/components/DashFilterBar';
import AddDescriptionModal from '@/language/pt/components/AddDescriptionModal';
import AnnotationTextCard from '@/language/pt/components/AnnotationTextCard';
import MenuBar from '@/language/pt/components/MenuBar';
import HelpButton from '@/language/pt/components/HelpButton';
import PublicAccessModal from '@/language/pt/components/PublicAccessModal';
import Onboarding from '@/language/pt/components/Onboarding';
import EnvironmentInfo from '@/language/pt/components/EnvironmentInfo';
import AnnotationImageCard from '@/language/pt/components/AnnotationImageCard';
import FileImporter from '@/language/pt/components/FileImporter';
import ImportHistory from '@/language/pt/components/ImportHistory';
import TextFilter from '@/language/pt/components/TextFilter';
import OptionsButton from '@/language/pt/components/OptionsButton';
import StatusTable from '@/language/pt/components/StatusTable';
import UserMenu from '@/language/pt/components/UserMenu';
import ComponentBuildModal from '@/language/pt/components/ComponentBuildModal';
import BlipMessageVolumeInPeriod from '@/language/pt/components/BlipMessageVolumeInPeriod';
import BlipEngagedAndNonEngagedContacts from '@/language/pt/components/BlipEngagedAndNonEngagedContacts';
import BlipActiveMessagesByChannel from '@/language/pt/components/BlipActiveMessagesByChannel';
import ConsolidatedCSATPieChart from '@/language/pt/components/ConsolidatedCSATPieChart';

export default {
  config,
  filters,
  models,
  filter,
  PublishSwitch,
  CardModal,
  DashCardsContainer,
  CopyToClipboard,
  AddCardModal,
  HiddenCardsModal,
  RemoveCardModal,
  Impress,
  GlobalFilter,
  GlobalFilterModal,
  GlobalFilterSummary,
  OperatorsLogs,
  Badge,
  DashFilterBar,
  AddDescriptionModal,
  AnnotationTextCard,
  MenuBar,
  HelpButton,
  PublicAccessModal,
  Onboarding,
  EnvironmentInfo,
  AnnotationImageCard,
  FileImporter,
  ImportHistory,
  TextFilter,
  OptionsButton,
  StatusTable,
  UserMenu,
  ComponentBuildModal,
  BlipMessageVolumeInPeriod,
  BlipEngagedAndNonEngagedContacts,
  BlipActiveMessagesByChannel,
  ConsolidatedCSATPieChart,
};
